{
    "Accessibility Menu": "辅助功能菜单",
    "Reset settings": "重置设置",
    "Close": "关闭",
    "Content Adjustments": "内容调整",
    "Adjust Font Size": "调整字体大小",
    "Highlight Title": "标题高亮",
    "Highlight Links": "链接高亮",
    "Readable Font": "易读字体",
    "Color Adjustments": "色彩调整",
    "Dark Contrast": "高对比度（黑色）",
    "Light Contrast": "高对比度（白色）",
    "High Contrast": "高对比度",
    "High Saturation": "高饱和度",
    "Low Saturation": "低饱和度",
    "Monochrome": "单色",
    "Tools": "更多设置",
    "Reading Guide": "阅读尺",
    "Stop Animations": "停止闪动",
    "Big Cursor": "放大鼠标",
    "Protanopia": "红色盲",
    "Deuteranopia": "绿色盲",
    "Tritanopia": "蓝色盲",
    "Visual & Navigation Aids": "视觉与导航辅助",
    "Additional Tools": "其他工具",
    "Screen Reader": "屏幕阅读器",
    "Hide Images": "隐藏图片",
    "Image Tooltips": "图片提示",
    "Page Structure": "页面结构",
    "Super Focus": "超级焦点",
    "Magnifier": "放大镜",
    "Increase Font Size": "增加字体大小",
    "Decrease Font Size": "减小字体大小",
    "Letter Spacing": "字母间距",
    "Line Height": "行距",
    "Font Weight": "字重",
    "Dyslexia Font": "阅读障碍字体",
    "Language": "语言",
    "Open Accessibility Menu": "打开辅助功能菜单",
    "Accessibility Profiles": "辅助功能档案",
    "Seizure Safe Profile": "癫痫安全档案",
    "Stops animations and reduces color saturation.": "停止动画并降低色彩饱和度。",
    "Blind Profile": "盲人档案",
    "Activates the screen reader for auditory navigation.": "激活屏幕阅读器以进行听觉导航。",
    "Visually Impaired Profile": "视力障碍档案",
    "Enhances contrast and readability for low vision.": "提升低视力用户的对比度和可读性。",
    "ADHD Friendly Profile": "ADHD 友好档案",
    "Reduces distractions for better focus.": "减少干扰以更好地集中注意力。",
    "Cognitive & Learning Profile": "认知与学习档案",
    "Helpful tools for reading and comprehension.": "有助于阅读和理解的工具。",
    "Motor Impaired Profile": "运动障碍档案",
    "Optimizes the site for keyboard-only navigation.": "优化网站以支持纯键盘导航。",
    "Headings": "标题",
    "Landmarks": "地标",
    "Links": "链接",
    "Focus element": "聚焦元素",
    "Visit link": "访问链接"
}